import { SERVER_DOMAIN } from '../project_config';

export const LoginHelper = (() => {
	var obj = {};
	obj.MODE_TYPE_USER = 'user';
	obj.MODE_TYPE_DOCTOR = 'doctor';
	obj.MODE_TYPE_ADMIN = 'admin';
	obj.TOKEN_KEY = 'token';
	obj.PROFILE_ID_KEY = 'profile_id';
	obj.PROFILE_MODE_KEY = 'profile_mode';
	obj.LOGIN_DATE_KEY = 'login_date';

	obj.isLoggedIn = () => {
		if (obj.getToken() === null) {
			return false;
		}
		let lastLoginDateStr = localStorage.getItem(obj.LOGIN_DATE_KEY);
		if (!lastLoginDateStr) {
			return false;
		}
		let diffSeconds = obj._getDiffSeconds(lastLoginDateStr);
		if (diffSeconds >= 60 * 60 * 24 * 10) {
			return false;
		}
		return true;
	}

	obj.getToken = () => {
		return localStorage.getItem(obj.TOKEN_KEY);
	};

	obj.getProfileId = () => {
		return localStorage.getItem(obj.PROFILE_ID_KEY);
	};

	obj.getProfileMode = () => {
		return localStorage.getItem(obj.PROFILE_MODE_KEY);
	};

	obj.setProfileMode = (profileMode) => {
		if (profileMode) {
			localStorage.setItem(obj.PROFILE_MODE_KEY, profileMode);
		}
	};

	/** After DB role changes, refresh mode from local backend without re-login. */
	obj.syncProfileModeFromServer = async () => {
		const token = obj.getToken();
		if (!token || !obj.isLoggedIn()) {
			return obj.getProfileMode();
		}
		try {
			const response = await fetch(`${SERVER_DOMAIN}/api/v1/profile/fetch_edit/`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ token }),
			});
			if (!response.ok) {
				return obj.getProfileMode();
			}
			const data = await response.json();
			if (data.mode) {
				obj.setProfileMode(data.mode);
			}
			if (data.id != null) {
				localStorage.setItem(obj.PROFILE_ID_KEY, String(data.id));
			}
			return obj.getProfileMode();
		} catch {
			return obj.getProfileMode();
		}
	};

	const notifyAuthChange = () => {
		try {
			window.dispatchEvent(new Event('app-auth-change'));
		} catch {
			/* ignore */
		}
	};

	obj.login = (token, profileId, profileMode) => {
		localStorage.setItem(obj.TOKEN_KEY, token);
		localStorage.setItem(obj.PROFILE_ID_KEY, profileId);
		localStorage.setItem(obj.PROFILE_MODE_KEY, profileMode);
		localStorage.setItem(obj.LOGIN_DATE_KEY, new Date().toISOString());
		notifyAuthChange();
	};

	obj.logout = () => {
		localStorage.removeItem(obj.TOKEN_KEY);
		localStorage.removeItem(obj.PROFILE_ID_KEY);
		localStorage.removeItem(obj.PROFILE_MODE_KEY);
		localStorage.removeItem(obj.LOGIN_DATE_KEY);
		notifyAuthChange();
	};

	obj._getDiffSeconds = (loginDateStr) => {
		const storedDate = new Date(loginDateStr);
		const now = new Date();
		const diffMs = now - storedDate; // difference in milliseconds
		const diffSeconds = Math.floor(diffMs / 1000);
		return diffSeconds;
	};

	return obj;
})();
